import { forwardRef, type Ref, type SVGProps } from "react";
const IconClockFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m6 16h-6a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v8h5a1 1 0 0 1 0 2" />
  </svg>
);
const ForwardRef = forwardRef(IconClockFilledSVG);
ForwardRef.displayName = "IconClockFilled";
export { ForwardRef as IconClockFilled };
